// Translations for GiCleanly - PT (Portuguese) and EN (British English)

export const translations = {
  en: {
    // Nav
    'nav.home': 'Home',
    'nav.about': 'About Us',
    'nav.services': 'Services',
    'nav.pricing': 'Pricing',
    'nav.areas': 'Areas',
    'nav.faq': 'FAQ',
    'nav.contact': 'Contact',
    'nav.freeEstimate': 'Free Estimate',

    // Topbar
    'top.hours': 'Mon – Sat: 8:00 – 20:00',
    'top.free': 'Free estimates within 24h',
    'top.callUs': 'Call us:',

    // Hero slides
    'hero.s1.tag': 'PROFESSIONAL SERVICE',
    'hero.s1.title': 'Sparkling Homes,',
    'hero.s1.highlight': 'Every Time.',
    'hero.s1.sub': 'A cleaning service you can truly rely on — from top to bottom, we handle it all.',
    'hero.s1.cta': 'Get a Free Estimate',

    'hero.s2.tag': 'ECO-FRIENDLY',
    'hero.s2.title': 'Green Cleaning,',
    'hero.s2.highlight': 'Healthy Living.',
    'hero.s2.sub': 'We use eco-friendly products that are safe for your family, pets and the planet.',
    'hero.s2.cta': 'Book Your Clean',

    'hero.s3.tag': 'TRUSTED IN LONDON',
    'hero.s3.title': '5-Star Rated,',
    'hero.s3.highlight': 'Fully Insured.',
    'hero.s3.sub': 'DBS-checked cleaners, public liability insurance and a 100% satisfaction guarantee on every visit.',
    'hero.s3.cta': 'Book Your Clean',

    'hero.ourServices': 'Our Services',

    // Slogan
    'slogan': 'A COMPANY WORKING FOR YOU',

    // Services
    'services.kicker': 'What We Offer',
    'services.heading1': 'Cleaning services',
    'services.heading2': 'designed around you',

    'svc.residential.kicker': 'Residential',
    'svc.residential.title': 'Cleaning',
    'svc.residential.desc': 'When you work with GiCleanly you can cross a major chore off your list — cleaning your home.',
    'svc.residential.sub': 'One Time Residential Cleaning / Recurring',

    'svc.commercial.kicker': 'Commercial',
    'svc.commercial.title': 'Cleaning',
    'svc.commercial.desc': 'At GiCleanly we use a wide variety of cleaning methods, chemicals, and equipment to facilitate and expedite the cleaning process.',
    'svc.commercial.sub': 'One Time Commercial Cleaning / Recurring',

    'svc.getEstimate': 'Get a Free Estimate',

    // Reasons
    'reasons.kicker': 'Why Choose Us',
    'reasons.heading1': 'Reasons Why',
    'reasons.heading2': 'People Choose Us',
    'reasons.1.stat': 'Monthly',
    'reasons.1.label': '500 cleans',
    'reasons.1.desc': 'Our microfiber cloths capture dust and dirt rather than move it around, and last longer than traditional cotton.',
    'reasons.2.stat': '100%',
    'reasons.2.label': 'Satisfaction',
    'reasons.2.desc': 'A money-back guarantee. If you are not satisfied, let us know within 48 hours after the service.',
    'reasons.3.stat': 'Eco-Friendly',
    'reasons.3.label': 'Cleaning Products',
    'reasons.3.desc': 'Because indoor pollution is typically higher than outdoor, we take dust removal seriously.',
    'reasons.4.stat': 'Cost',
    'reasons.4.label': 'Effective',
    'reasons.4.desc': 'Precision cleaning at prices that make sense for homes and businesses across London.',

    // Trust badges
    'trust.kicker': 'Peace of Mind',
    'trust.heading': 'You’re in safe hands',
    'trust.1.title': 'Fully Insured',
    'trust.1.desc': 'Every clean covered by public liability insurance.',
    'trust.2.title': 'DBS Checked',
    'trust.2.desc': 'All cleaners background-verified for your safety.',
    'trust.3.title': 'Eco Products',
    'trust.3.desc': 'Safe for children, pets and the environment.',
    'trust.4.title': 'Money-Back',
    'trust.4.desc': '48h satisfaction guarantee on every service.',
    'trust.5.title': '5-Star Rated',
    'trust.5.desc': '82+ verified reviews across Google.',
    'trust.6.title': '24h Response',
    'trust.6.desc': 'Quick quotes and confirmations, same day.',

    // Calculator
    'calc.kicker': 'Instant Estimate',
    'calc.heading1': 'Get your price',
    'calc.heading2': 'in seconds',
    'calc.sub': 'A quick estimate before you book. Adjust below and see the price update live.',
    'calc.type': 'Property type',
    'calc.type.residential': 'Residential',
    'calc.type.commercial': 'Commercial',
    'calc.size': 'Size',
    'calc.size.1': '1 bedroom',
    'calc.size.2': '2 bedrooms',
    'calc.size.3': '3 bedrooms',
    'calc.size.4': '4+ bedrooms',
    'calc.size.office': 'Office / Other',
    'calc.freq': 'Frequency',
    'calc.freq.oneoff': 'One-off',
    'calc.freq.weekly': 'Weekly',
    'calc.freq.biweekly': 'Bi-weekly',
    'calc.freq.monthly': 'Monthly',
    'calc.extras': 'Extras',
    'calc.extras.windows': 'Windows',
    'calc.extras.oven': 'Oven',
    'calc.extras.fridge': 'Fridge',
    'calc.extras.carpet': 'Carpet',
    'calc.extras.ironing': 'Ironing',
    'calc.total': 'Estimated total',
    'calc.perVisit': 'per visit',
    'calc.disclaimer': '*Approximate estimate. Final price confirmed after property assessment.',
    'calc.bookNow': 'Book at this price',

    // Areas
    'areas.kicker': 'Coverage',
    'areas.heading1': 'Proudly serving',
    'areas.heading2': 'all of London',
    'areas.sub': 'From Central London to every borough — GiCleanly is just around the corner.',
    'areas.central': 'Central London',
    'areas.north': 'North London',
    'areas.south': 'South London',
    'areas.east': 'East London',
    'areas.west': 'West London',
    'areas.notSure': 'Not sure if we cover your area? Message us on WhatsApp — we probably do!',

    // Testimonials
    'test.kicker': 'Our Reviews',
    'test.heading': 'GiCleanly',
    'test.count': '82 Google reviews',

    // Steps
    'steps.kicker': 'Our Process',
    'steps.heading1': '…easy as 1-2-3',
    'steps.heading2': 'See How It Works',
    'steps.1.title': 'Easy Online Scheduling',
    'steps.1.sub': 'Just a Few Clicks',
    'steps.2.title': 'Cleaning with Care',
    'steps.2.sub': 'and Eco-Friendly Products',
    'steps.3.title': 'Enjoy Cleanliness',
    'steps.3.sub': 'and Shine Around You',

    // FAQ
    'faq.kicker': 'Questions',
    'faq.heading1': 'Frequently Asked',
    'faq.heading2': 'Questions',
    'faq.q1': 'Do I need to provide cleaning products?',
    'faq.a1': 'No — we bring everything. All our products are eco-friendly and safe for pets and children. If you’d prefer we use your own products, just let us know.',
    'faq.q2': 'Are your cleaners insured and background-checked?',
    'faq.a2': 'Yes. Every GiCleanly professional is DBS-checked, fully trained and covered by our public liability insurance.',
    'faq.q3': 'How long does a typical clean take?',
    'faq.a3': 'A regular 2-bedroom flat takes around 2 to 3 hours. Deep cleans and end-of-tenancy jobs can take 4 to 6 hours depending on the size and condition.',
    'faq.q4': 'What if I’m not happy with the service?',
    'faq.a4': 'Let us know within 48 hours and we’ll come back and re-clean any missed spots free of charge — that’s our 100% satisfaction guarantee.',
    'faq.q5': 'Can I cancel or reschedule?',
    'faq.a5': 'Absolutely. Just message us on WhatsApp at least 24h in advance and we’ll rearrange with no fee.',
    'faq.q6': 'How do I pay?',
    'faq.a6': 'We accept bank transfer, card and cash on the day. Recurring clients receive a monthly invoice by email.',

    // Contact
    'contact.kicker': 'Contact Us',
    'contact.heading1': 'We’re your local',
    'contact.brand': 'GiCleanly',
    'contact.heading2': 'crew',
    'contact.sub': 'We are your local home cleaning services professionals and pledge to clean thoroughly, completely and reliably.',
    'contact.callFor': 'Call for a free estimate',
    'contact.email': 'Email',
    'contact.form.title': 'Get a Free Estimate',
    'contact.form.sub': 'Tell us about your space and we\u2019ll get back to you within 24 hours.',
    'contact.form.mention': 'Mention code',
    'contact.form.mentionAfter': 'for a great service.',
    'contact.form.name': 'Your name',
    'contact.form.email': 'Email address',
    'contact.form.phone': 'Phone (optional)',
    'contact.form.message': 'Tell us about your space…',
    'contact.form.send': 'Send Request',
    'contact.toast.missing': 'Missing info',
    'contact.toast.missingDesc': 'Please add your name and email so we can reach you.',
    'contact.toast.sent': 'Estimate request sent!',
    'contact.toast.sentDesc': 'We’ll reply within 24 hours.',

    // Footer
    'footer.tagline': 'Reliable residential & commercial cleaning across London — eco-friendly products, insured, satisfaction guaranteed by GiCleanly.',
    'footer.company': 'Company',
    'footer.services': 'Services',
    'footer.getInTouch': 'Get in touch',
    'footer.residential': 'Residential Cleaning',
    'footer.commercial': 'Commercial Cleaning',
    'footer.endTenancy': 'End of Tenancy',
    'footer.deep': 'Deep Clean',
    'footer.carpet': 'Carpet Cleaning',
    'footer.postConst': 'Post Construction',
    'footer.chatWA': 'Chat on WhatsApp',
    'footer.rights': 'All rights reserved.',
    'footer.privacy': 'Privacy Policy',
    'footer.terms': 'Terms of Service',
    'footer.cookies': 'Cookies',

    // Booking modal
    'book.title': 'Book your clean',
    'book.kicker': 'Booking',
    'book.step': 'Step',
    'book.of': 'of',
    'book.step1': 'What do you need cleaned?',
    'book.residential': 'Residential',
    'book.residential.desc': 'Home & apartment',
    'book.commercial': 'Commercial',
    'book.commercial.desc': 'Office & shops',
    'book.deep': 'Deep Clean',
    'book.deep.desc': 'One-off intensive',
    'book.endTen': 'End of Tenancy',
    'book.endTen.desc': 'Move in / out',
    'book.propSize': 'Property size',
    'book.howOften': 'How often?',
    'book.when': 'When would you like us?',
    'book.date': 'Preferred date',
    'book.time': 'Preferred time',
    'book.anyTime': 'Any time',
    'book.morning': 'Morning (8-12)',
    'book.afternoon': 'Afternoon (12-17)',
    'book.evening': 'Evening (17-20)',
    'book.address': 'Address',
    'book.addressPh': 'Street, city, postcode',
    'book.notes': 'Notes (optional)',
    'book.notesPh': 'Pets, keys, parking…',
    'book.contact': 'Your contact details',
    'book.name': 'Full name*',
    'book.phone': 'Phone*',
    'book.email': 'Email',
    'book.summary': 'Booking summary',
    'book.service': 'Service:',
    'book.size': 'Size:',
    'book.freq': 'Frequency:',
    'book.dateL': 'Date:',
    'book.confirm': 'Confirm Booking',
    'book.back': 'Back',
    'book.next': 'Next',
    'book.toast.miss': 'Missing info',
    'book.toast.missDesc': 'Please add your name and phone.',
    'book.toast.ok': 'Booking request received!',
    'book.toast.okDesc': 'Thanks! We’ll confirm your booking shortly.',
  },

  pt: {
    // Nav
    'nav.home': 'Início',
    'nav.about': 'Sobre',
    'nav.services': 'Serviços',
    'nav.pricing': 'Preços',
    'nav.areas': 'Áreas',
    'nav.faq': 'Dúvidas',
    'nav.contact': 'Contato',
    'nav.freeEstimate': 'Orçamento Grátis',

    'top.hours': 'Seg – Sáb: 8:00 – 20:00',
    'top.free': 'Orçamento grátis em 24h',
    'top.callUs': 'Ligue:',

    'hero.s1.tag': 'SERVIÇO PROFISSIONAL',
    'hero.s1.title': 'Casas Brilhando,',
    'hero.s1.highlight': 'Sempre.',
    'hero.s1.sub': 'Um serviço de limpeza em que você pode confiar — do teto ao chão, cuidamos de tudo.',
    'hero.s1.cta': 'Orçamento Grátis',

    'hero.s2.tag': 'ECOLÓGICO',
    'hero.s2.title': 'Limpeza Verde,',
    'hero.s2.highlight': 'Vida Saudável.',
    'hero.s2.sub': 'Usamos produtos ecológicos, seguros para sua família, pets e o planeta.',
    'hero.s2.cta': 'Agende Agora',

    'hero.s3.tag': 'CONFIANÇA EM LONDRES',
    'hero.s3.title': '5 Estrelas,',
    'hero.s3.highlight': 'Totalmente Segurado.',
    'hero.s3.sub': 'Equipe verificada pelo DBS, seguro de responsabilidade civil e garantia de 100% de satisfação em cada visita.',
    'hero.s3.cta': 'Agende Agora',

    'hero.ourServices': 'Nossos Serviços',

    'slogan': 'UMA EMPRESA TRABALHANDO POR VOCÊ',

    'services.kicker': 'O Que Oferecemos',
    'services.heading1': 'Serviços de limpeza',
    'services.heading2': 'feitos para você',

    'svc.residential.kicker': 'Limpeza',
    'svc.residential.title': 'Residencial',
    'svc.residential.desc': 'Ao contratar a GiCleanly você tira uma grande tarefa da sua lista — limpar a casa.',
    'svc.residential.sub': 'Avulsa ou recorrente',

    'svc.commercial.kicker': 'Limpeza',
    'svc.commercial.title': 'Comercial',
    'svc.commercial.desc': 'Na GiCleanly usamos métodos, produtos e equipamentos variados para facilitar e agilizar a limpeza.',
    'svc.commercial.sub': 'Avulsa ou recorrente',

    'svc.getEstimate': 'Pedir Orçamento',

    'reasons.kicker': 'Por Que Nos Escolher',
    'reasons.heading1': 'Motivos Para',
    'reasons.heading2': 'Escolher a GiCleanly',
    'reasons.1.stat': 'Mensal',
    'reasons.1.label': '500 limpezas',
    'reasons.1.desc': 'Nossos panos de microfibra capturam a poeira em vez de espalhá-la e duram mais que os panos comuns.',
    'reasons.2.stat': '100%',
    'reasons.2.label': 'Satisfação',
    'reasons.2.desc': 'Garantia de devolução. Se não ficar satisfeito, avise em até 48h após o serviço.',
    'reasons.3.stat': 'Ecológicos',
    'reasons.3.label': 'Produtos de Limpeza',
    'reasons.3.desc': 'A poluição interna costuma ser maior que a externa — por isso levamos a limpeza a sério.',
    'reasons.4.stat': 'Custo',
    'reasons.4.label': 'Justo',
    'reasons.4.desc': 'Limpeza precisa a preços que fazem sentido para casas e negócios em toda Londres.',

    'trust.kicker': 'Tranquilidade',
    'trust.heading': 'Você está em boas mãos',
    'trust.1.title': 'Totalmente Segurado',
    'trust.1.desc': 'Todo serviço coberto por seguro de responsabilidade civil.',
    'trust.2.title': 'Equipe Verificada',
    'trust.2.desc': 'Todos os profissionais checados pelo DBS.',
    'trust.3.title': 'Produtos Eco',
    'trust.3.desc': 'Seguros para crianças, pets e o meio ambiente.',
    'trust.4.title': 'Garantia',
    'trust.4.desc': 'Satisfação garantida em até 48h ou refazemos.',
    'trust.5.title': '5 Estrelas',
    'trust.5.desc': 'Mais de 82 avaliações verificadas no Google.',
    'trust.6.title': 'Resposta 24h',
    'trust.6.desc': 'Orçamentos e confirmações no mesmo dia.',

    'calc.kicker': 'Estimativa Instantânea',
    'calc.heading1': 'Veja seu preço',
    'calc.heading2': 'em segundos',
    'calc.sub': 'Uma estimativa rápida antes de agendar. Ajuste abaixo e veja o preço em tempo real.',
    'calc.type': 'Tipo do imóvel',
    'calc.type.residential': 'Residencial',
    'calc.type.commercial': 'Comercial',
    'calc.size': 'Tamanho',
    'calc.size.1': '1 quarto',
    'calc.size.2': '2 quartos',
    'calc.size.3': '3 quartos',
    'calc.size.4': '4+ quartos',
    'calc.size.office': 'Escritório / Outro',
    'calc.freq': 'Frequência',
    'calc.freq.oneoff': 'Avulsa',
    'calc.freq.weekly': 'Semanal',
    'calc.freq.biweekly': 'Quinzenal',
    'calc.freq.monthly': 'Mensal',
    'calc.extras': 'Extras',
    'calc.extras.windows': 'Janelas',
    'calc.extras.oven': 'Forno',
    'calc.extras.fridge': 'Geladeira',
    'calc.extras.carpet': 'Carpete',
    'calc.extras.ironing': 'Passar roupa',
    'calc.total': 'Total estimado',
    'calc.perVisit': 'por visita',
    'calc.disclaimer': '*Estimativa aproximada. Preço final confirmado após avaliação do imóvel.',
    'calc.bookNow': 'Agendar por este preço',

    'areas.kicker': 'Cobertura',
    'areas.heading1': 'Atendemos',
    'areas.heading2': 'toda Londres',
    'areas.sub': 'Do centro a cada borough — a GiCleanly está pertinho de você.',
    'areas.central': 'Central London',
    'areas.north': 'North London',
    'areas.south': 'South London',
    'areas.east': 'East London',
    'areas.west': 'West London',
    'areas.notSure': 'Não sabe se atendemos sua região? Mande WhatsApp — provavelmente atendemos!',

    'test.kicker': 'Avaliações',
    'test.heading': 'GiCleanly',
    'test.count': '82 avaliações no Google',

    'steps.kicker': 'Como Funciona',
    'steps.heading1': '…fácil como 1-2-3',
    'steps.heading2': 'Veja como funciona',
    'steps.1.title': 'Agendamento Fácil',
    'steps.1.sub': 'Em poucos cliques',
    'steps.2.title': 'Limpeza com Cuidado',
    'steps.2.sub': 'e Produtos Ecológicos',
    'steps.3.title': 'Aproveite',
    'steps.3.sub': 'a limpeza e o brilho ao seu redor',

    'faq.kicker': 'Dúvidas',
    'faq.heading1': 'Perguntas',
    'faq.heading2': 'Frequentes',
    'faq.q1': 'Preciso fornecer os produtos de limpeza?',
    'faq.a1': 'Não — levamos tudo. Nossos produtos são ecológicos e seguros para pets e crianças. Se preferir que usemos seus produtos, é só avisar.',
    'faq.q2': 'A equipe é segurada e verificada?',
    'faq.a2': 'Sim. Todo profissional da GiCleanly passa por verificação DBS, é treinado e coberto pelo nosso seguro de responsabilidade civil.',
    'faq.q3': 'Quanto tempo dura uma limpeza?',
    'faq.a3': 'Um apartamento de 2 quartos costuma levar de 2 a 3 horas. Limpezas profundas e fim de contrato podem levar de 4 a 6 horas.',
    'faq.q4': 'E se eu não gostar do serviço?',
    'faq.a4': 'Nos avise em até 48h e voltamos para refazer os pontos sem custo — essa é nossa garantia de 100% de satisfação.',
    'faq.q5': 'Posso cancelar ou remarcar?',
    'faq.a5': 'Claro. É só mandar WhatsApp com pelo menos 24h de antecedência — remarcamos sem taxa.',
    'faq.q6': 'Como faço o pagamento?',
    'faq.a6': 'Aceitamos transferência, cartão e dinheiro no dia. Clientes recorrentes recebem fatura mensal por e-mail.',

    'contact.kicker': 'Fale Conosco',
    'contact.heading1': 'Sua equipe local',
    'contact.brand': 'GiCleanly',
    'contact.heading2': 'em Londres',
    'contact.sub': 'Somos profissionais de limpeza local e nos comprometemos com uma limpeza completa e confiável.',
    'contact.callFor': 'Ligue para orçamento grátis',
    'contact.email': 'E-mail',
    'contact.form.title': 'Orçamento Grátis',
    'contact.form.sub': 'Conte sobre seu espaço e respondemos em até 24 horas.',
    'contact.form.mention': 'Use o código',
    'contact.form.mentionAfter': 'para um ótimo serviço.',
    'contact.form.name': 'Seu nome',
    'contact.form.email': 'E-mail',
    'contact.form.phone': 'Telefone (opcional)',
    'contact.form.message': 'Conte sobre seu espaço…',
    'contact.form.send': 'Enviar Pedido',
    'contact.toast.missing': 'Faltam informações',
    'contact.toast.missingDesc': 'Adicione nome e e-mail para entrarmos em contato.',
    'contact.toast.sent': 'Pedido enviado!',
    'contact.toast.sentDesc': 'Respondemos em até 24 horas.',

    'footer.tagline': 'Limpeza residencial e comercial em toda Londres — produtos ecológicos, seguros e satisfação garantida pela GiCleanly.',
    'footer.company': 'Empresa',
    'footer.services': 'Serviços',
    'footer.getInTouch': 'Contato',
    'footer.residential': 'Limpeza Residencial',
    'footer.commercial': 'Limpeza Comercial',
    'footer.endTenancy': 'Fim de Contrato',
    'footer.deep': 'Limpeza Profunda',
    'footer.carpet': 'Limpeza de Carpete',
    'footer.postConst': 'Pós-Obra',
    'footer.chatWA': 'Falar no WhatsApp',
    'footer.rights': 'Todos os direitos reservados.',
    'footer.privacy': 'Privacidade',
    'footer.terms': 'Termos de Uso',
    'footer.cookies': 'Cookies',

    'book.title': 'Agende sua limpeza',
    'book.kicker': 'Agendamento',
    'book.step': 'Passo',
    'book.of': 'de',
    'book.step1': 'O que você precisa limpar?',
    'book.residential': 'Residencial',
    'book.residential.desc': 'Casa & apartamento',
    'book.commercial': 'Comercial',
    'book.commercial.desc': 'Escritórios & lojas',
    'book.deep': 'Limpeza Profunda',
    'book.deep.desc': 'Intensiva avulsa',
    'book.endTen': 'Fim de Contrato',
    'book.endTen.desc': 'Mudança',
    'book.propSize': 'Tamanho do imóvel',
    'book.howOften': 'Com que frequência?',
    'book.when': 'Quando gostaria?',
    'book.date': 'Data preferida',
    'book.time': 'Horário preferido',
    'book.anyTime': 'Qualquer horário',
    'book.morning': 'Manhã (8-12)',
    'book.afternoon': 'Tarde (12-17)',
    'book.evening': 'Noite (17-20)',
    'book.address': 'Endereço',
    'book.addressPh': 'Rua, cidade, CEP',
    'book.notes': 'Observações (opcional)',
    'book.notesPh': 'Pets, chaves, estacionamento…',
    'book.contact': 'Seus dados de contato',
    'book.name': 'Nome completo*',
    'book.phone': 'Telefone*',
    'book.email': 'E-mail',
    'book.summary': 'Resumo do agendamento',
    'book.service': 'Serviço:',
    'book.size': 'Tamanho:',
    'book.freq': 'Frequência:',
    'book.dateL': 'Data:',
    'book.confirm': 'Confirmar Agendamento',
    'book.back': 'Voltar',
    'book.next': 'Próximo',
    'book.toast.miss': 'Faltam informações',
    'book.toast.missDesc': 'Adicione seu nome e telefone.',
    'book.toast.ok': 'Pedido de agendamento recebido!',
    'book.toast.okDesc': 'Obrigado! Confirmaremos seu agendamento em breve.',
  },
};
